import { render, staticRenderFns } from "./GdprApproval.vue?vue&type=template&id=27eb5108&scoped=true&"
import script from "./GdprApproval.vue?vue&type=script&lang=ts&"
export * from "./GdprApproval.vue?vue&type=script&lang=ts&"
import style0 from "./GdprApproval.vue?vue&type=style&index=0&id=27eb5108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb5108",
  null
  
)

export default component.exports